import roundNum from 'lodash/round';

import { Tendency, TendencyChange } from '@cast/shared-types';

type GetTendencyChangeOptions = {
  percentage?: boolean;
  round?: false | number;
};

export const getTendencyChange = (
  current: number,
  previous: number,
  { percentage, round = 2 }: GetTendencyChangeOptions = {}
): TendencyChange => {
  let tendency: Tendency = 'stable';
  if (current > previous) {
    tendency = 'up';
  } else if (current < previous) {
    tendency = 'down';
  }
  let resultDiff = Math.abs(current - previous);
  if (percentage) {
    if (previous === current) {
      resultDiff = 0;
    } else if ([previous, current].includes(0)) {
      resultDiff = 100;
    } else {
      resultDiff =
        current > previous
          ? (current / previous - 1) * 100
          : (previous / current - 1) * 100;
    }
  }
  return {
    tendency,
    diff: round ? roundNum(resultDiff, round) : resultDiff,
  };
};
